import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

import { useState } from 'react';

const Layout = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const { pathname } = useLocation();
  const normalizedPath = pathname.replace(/\/$/, '');
  const hideMainScrollbar = normalizedPath === '/dashboard';
  const isRedeemPage = normalizedPath === '/wallet';

  return (
    <div className='flex h-screen overflow-hidden'>
      {/* Sidebar: hidden on small screens, visible on md+ */}
      <div
        className={`fixed lg:static inset-y-0 left-0 z-40 transition-transform transform ${
          isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:translate-x-0 shrink-0`}
      >
        <Sidebar closeSidebar={() => setSidebarOpen(false)} />
      </div>

      {/* Backdrop only on mobile when sidebar is open */}
      {isSidebarOpen && (
        <div
          className='fixed inset-0 bg-black bg-opacity-20 z-30 lg:hidden'
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}

      <div className='flex flex-col flex-1 overflow-hidden bg-[#F5F6F8]'>
        <Topbar openSidebar={() => setSidebarOpen(true)} />

        <main
          className={`flex-1 overflow-auto${isRedeemPage ? ' bg-[#f4f6f9]' : ' py-[var(--main-content-pad-y)] px-[var(--main-content-pad-x)]'}${hideMainScrollbar ? ' scrollbar-hide' : ''}`}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
